import { Link } from 'react-router-dom';
import { CoreButton, CoreButtonProps } from '@youscience/core';

export interface CoreLinkButtonProps extends Omit<CoreButtonProps, 'component' | 'to'> {
  to: string;
}

export const CoreLinkButton = (props: CoreLinkButtonProps) => {
  const { ariaLabel, children, to = '/', ...rest } = props;

  return (
    <CoreButton ariaLabel={ariaLabel} component={Link} to={to} {...rest}>
      {children}
    </CoreButton>
  );
};
